import { useQuery } from "@tanstack/react-query";
import { mockOrderEntryData } from "../../../../mocks/backOffice/clientServices/pickupReviewDetail.mocks";

export const useRateQuoteReview = () => {
  const query = useQuery({
    queryKey: ["rateQuoteReview"],
    queryFn: () => mockOrderEntryData,
  });

  return query;
};
